import $http from "../../axios";import {Notification, MessageBox} from 'element-ui';


export async function fetchReportInventoryReplacement({commit, state}) {
    state.loading.module = true;
    await $http.get('/api/reporte-reposicion-inventario',{params : state.params}).then((response) => {
            state.loading.module = false;
            commit('setInventoryReplacement', response.data.data)
        })
        .catch((error) => {
            state.loading.module = false;
            Notification.error({
                title: 'Error!',
                message: error.response.data.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}
export async function fetchReportInventoryReplacementInfo({commit, state},params) {
    await $http.get('/api/reporte-reposicion-inventario-detalle',{params : params}).then((response) => {
            commit('setInventoryReplacementDetail', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.response.data.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}
export async function fetchContacts({commit,state}, requestParameters = {params: state.params_query}) {
    await $http.get('/api/terceros', requestParameters)
        .then((response) => {
            commit('setContacts', response.data.data)

        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
}



// WEBPACK FOOTER //
// ./src/modules/report-inventory-replacement/actions.js